// src/modules/invoices/pages/InvoicePDFDownload.tsx

import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

type Props = {
  /** The `id` of the DOM element you want to convert to PDF. */
  elementId: string;
  /** Base file name (no extension). “invoice-1234”→ “invoice-1234.pdf”. */
  fileName: string;
};

export default function InvoicePDFDownload({ elementId, fileName }: Props) {
  const handleDownloadPDF = async () => {
    const element = document.getElementById(elementId);
    if (!element) {
      alert("Could not find invoice content to export.");
      return;
    }

    // Cast options to any so we can pass `scale: 2`
    const canvas = await html2canvas(element as HTMLElement, { scale: 2 } as any);
    const imgData = canvas.toDataURL("image/png");

    // Construct a jsPDF instance matching the canvas dimensions:
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: [canvas.width, canvas.height],
    });

    pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
    pdf.save(`${fileName}.pdf`);
  };

  return (
    <button
      onClick={handleDownloadPDF}
      className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
    >
      Download PDF
    </button>
  );
}